const content = {
  variantLabels: {
    active: "Status",
    attribute: "Attribute",
    barcode: "Bar Code",
    comparePrice: "Compare Price",
    height: "Height",
    images: "Variant Image",
    inventoryManagement: "Inventory Management",
    inventoryQuantity: "Inventory Quantity",
    isShipping: "Is Shipping",
    isTaxable: "Is Taxable",
    length: "Length",
    measurement: "Measurement",
    option1: "Option1",
    option1Val: "Option1 Value",
    option2: "Option2",
    option2Val: "Option2 Value",
    option3: "Option3",
    option3Val: "Option3 Value",
    position: "Position",
    priceId: "Price",
    // calculatedPrice: "Calculated Price",
    costPrice: "Sales Price",
    price: "Price",
    // regularPrice: "Regular Price",
    // salePrice: "Sale Price",
    inventoryId: "Inventory",
    isManagingStock: "Is Managing Stock",
    quantity: "Quantity",
    sku: "SKU",
    size: "Size",
    stock: "Stock",
    weight: "Weight",
    weightUnit: "Weight Unit",
    wholesalePrice: "Wholesale Price",
    width: "Width",
  },

  labels: {
    approveAll: "Accept and Publish",
    approveSelected: "Accept and Don't Publish",
    attachments: "Attachments",
    barcode: "Bar Code",
    category: "Category",
    collections: "Collections",
    comparePrice: "Compare Price",
    customMetafields: "Metafield",
    description: "Description",
    handle: "Handle",
    height: "Height",
    images: "Images",
    inventoryManagement: "Inventory Management",
    isShipping: "Is Shipping",
    isTaxable: "Is Taxable",
    length: "Length",
    markAs: "Don't Accept Changes",
    no: "No",
    name: "Title",
    priceId: "Price",
    productType: "Product Type",
    quantity: "Quantity",
    reviewChanges: "Review Product Changes",
    sellers: "Seller's Value",
    shopifyCatalogId: "Product Collection",
    sku: "SKU",
    tags: "Tags",
    title: "Title",
    type: "Type",
    variants: "Variants",
    vendor: "Vendor",
    vendors: "Vendor's Value",
    weight: "Weight",
    weightUnit: "WeightUnit",
    wholesalePrice: "Wholesale Price",
    width: "Width",
    yes: "Yes",
    // calculatedPrice: "Calculated Price",
    costPrice: "Sales Price",
    price: "Regular Price",
    // regularPrice: "Regular Price",
    // salePrice: "Sale Price",
    isManagingStock: "Is Managing Stock",
  },
};

export default content;
